import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HelpCircle, X, BookOpen, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function HelpWidget() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div data-testid="help-widget" className="fixed bottom-20 right-5 z-[9999]">
      {open && (
        <div className="absolute bottom-14 right-0 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden animate-fade-in-up">
          <div className="bg-gradient-to-r from-[#003366] to-[#004C99] p-4">
            <div className="flex items-center justify-between">
              <h3 className="text-white text-sm font-semibold font-['Barlow']">{t('help.widgetTitle')}</h3>
              <button onClick={() => setOpen(false)} className="text-white/70 hover:text-white"><X className="w-4 h-4" /></button>
            </div>
            <p className="text-blue-200/70 text-xs mt-1">{t('help.widgetSubtitle')}</p>
          </div>
          <div className="p-3 space-y-2">
            <button
              data-testid="help-widget-articles"
              onClick={() => { navigate('/help'); setOpen(false); }}
              className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors text-left"
            >
              <div className="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                <BookOpen className="w-4 h-4 text-blue-500" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">{t('help.widgetArticles')}</p>
                <p className="text-[11px] text-gray-400">{t('help.widgetArticlesDesc')}</p>
              </div>
            </button>
            <button
              data-testid="help-widget-support"
              onClick={() => { navigate('/settings'); setOpen(false); }}
              className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors text-left"
            >
              <div className="w-9 h-9 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-4 h-4 text-emerald-500" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">{t('help.widgetContact')}</p>
                <p className="text-[11px] text-gray-400">{t('help.widgetContactDesc')}</p>
              </div>
            </button>
          </div>
        </div>
      )}
      <Button
        data-testid="help-widget-toggle"
        onClick={() => setOpen(!open)}
        className={`w-12 h-12 rounded-full shadow-lg transition-all duration-300 ${
          open
            ? 'bg-gray-100 text-gray-600 hover:bg-gray-200 rotate-45'
            : 'bg-[#003366] text-white hover:bg-[#004080] hover:scale-110'
        }`}
      >
        {open ? <X className="w-5 h-5" /> : <HelpCircle className="w-5 h-5" />}
      </Button>
    </div>
  );
}
